module.exports = __webpack_public_path__ + "static/media/pos-icon.d2a280cc.svg";